document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('a.btn,.link a');

  buttons.forEach(button => {
    const href = button.getAttribute("href");

    if (href && href.startsWith("#") && href.length > 1) {
      button.addEventListener("click", function (event) {
        const targetId = href.slice(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          event.preventDefault();

          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = window.pageYOffset + elementPosition - 50;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    }
  });
});
